import Wrapper from "../../atoms/Wrapper";
import OrderStatus from "../ConfirmationInner/OrderStatus";
import React from "react";
import { Button, Stack, Text } from "@bookingcom/bui-react";
import { AlternativeFares } from "../AlternativeFares/AlternativeFares";
import useCheckoutAlternativeFaresController from "./useCheckoutAlternativeFares.controller";
import AlternativeFaresLegalMessages from "../AlternativeFares/AlternativeFaresLegalMessages";

const CheckoutAlternativeFaresInner = () => {
  const {
    alternativeFares,
    alternativeFaresLoading,
    alternativeFaresError,
    isSirfAvailable,
    title,
    subtitle,
    errorCta,
    onErrorClick
  } = useCheckoutAlternativeFaresController();

  return (
    <main role="main" id="basiclayout">
      <Wrapper noBorder>
        <OrderStatus status="ERROR" isPaymentCollection={false} />
        <Text tagName="h1" variant="headline_2">
          {title}
        </Text>

        {Array.isArray(subtitle) ? (
          <Stack gap={4}>
            {subtitle.map((s, i) => (
              <Text key={i} variant="body_2">
                {s}
              </Text>
            ))}
          </Stack>
        ) : (
          <Text variant="body_2">{subtitle}</Text>
        )}
      </Wrapper>

      <div style={{ position: "relative" }}>
        <Wrapper noBorder>
          {alternativeFaresError ? (
            <div>
              <Button
                text={errorCta}
                iconPosition="start"
                variant="primary"
                type="button"
                size="medium"
                wide={false}
                onClick={onErrorClick}
              />
            </div>
          ) : (
            <AlternativeFares isLoading={alternativeFaresLoading} alternativeFares={alternativeFares} />
          )}
        </Wrapper>

        {!!alternativeFares.length && (
          <Wrapper noBorder>
            <AlternativeFaresLegalMessages active={!!alternativeFares.length} isSirfActive={isSirfAvailable} />
          </Wrapper>
        )}
      </div>
    </main>
  );
};

export default CheckoutAlternativeFaresInner;
